import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { InfoblockService } from '@main/infoblock/feature';

@Component({
  selector: 'sd-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private infoblockService: InfoblockService) {}

  ngOnInit(): void {
    this.infoblockService.init();
  }
}
